export default __webpack_public_path__ + "static/media/infoIcon.f5ef7002.svg";